import React from 'react'
import styled from 'react-emotion'

const Warning = styled('div')`
  border-radius: 4px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .1);
  border-left: 6px solid #ffc20e;
  background-color: ${props => props.warning ? '#fff6db' : '#fff'};
  margin-bottom: 10px;
  padding: 20px;
`

export default ({ children, warning }) => {
  return (
    <Warning warning={warning}>
      {children}
    </Warning>
  )
}